(() => {
  const usageAreas = ['Face', 'Hair', 'Hands', 'Body', 'More than one area'];
  const lifestyleOptions = [
    'Beach/Sun Lovers',
    'Youthful Skin',
    'Post-Workout Skin',
    'Cold-Weather Skin',
    'Daily Moisturizer',
    'Frequent Travelers',
    'Minimalist Skincare',
    'Deep Nourishment',
    'None',
  ];
  const concernOptions = {
    Face: ['Sun damage', 'Dryness', 'Dark spots', 'Uneven tone', 'Rough texture', 'Scars', 'Breakouts', 'Fine lines', 'Sensitive skin', 'Barrier support', 'Skin elasticity', 'Glow', 'Simple & easy skincare', 'Recovery after sun exposure'],
    Hair: ['Shininess', 'Breakage', 'Styling', 'Dryness', 'Frizzy hair', 'Curly hair', 'Treated hair', 'Scalp care', 'Simple & easy hair care'],
    Hands: ['Dryness', 'Nail cuticles', 'Simple & easy hand care'],
    Body: ['Elbows', 'Knees', 'Dryness', 'Stretch marks', 'Scars', 'Barrier support', 'Simple & easy skincare', 'Recovery after sun exposure'],
  };

  const mappings = {
    acai: {
      priority: 7,
      usage: {
        Face: 'Strong match', Hair: 'Match', Hands: 'Match',
        Body: 'Match', 'More than one area': 'Match',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Match', 'Youthful Skin': 'Strong match',
        'Cold-Weather Skin': 'Match', 'Daily Moisturizer': 'Match',
        'Frequent Travelers': 'Strong match', 'Minimalist Skincare': 'Match',
        'Deep Nourishment': 'Match',
      },
      concerns: {
        Face: {
          'Sun damage': 'Match', Dryness: 'Match', 'Dark spots': 'Strong match',
          'Uneven tone': 'Strong match', 'Rough texture': 'Match', Scars: 'Match',
          Breakouts: 'Match', 'Fine lines': 'Match', 'Sensitive skin': 'Match',
          'Barrier support': 'Match', 'Skin elasticity': 'Match', Glow: 'Strong match',
          'Simple & easy skincare': 'Match', 'Recovery after sun exposure': 'Strong match',
        },
        Hair: {
          Shininess: 'Match', 'Scalp care': 'Match',
        },
        Hands: {
          Dryness: 'Match', 'Nail cuticles': 'Match', 'Simple & easy hand care': 'Match',
        },
        Body: {
          Dryness: 'Match', Scars: 'Match', 'Barrier support': 'Match',
          'Simple & easy skincare': 'Match', 'Recovery after sun exposure': 'Strong match',
        },
      },
    },
    andiroba: {
      priority: 3,
      usage: {
        Face: 'Strong match', Hair: 'Strong match', Hands: 'Strong match',
        Body: 'Strong match', 'More than one area': 'Strong match',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Match', 'Youthful Skin': 'Match', 'Post-Workout Skin': 'Strong match',
        'Cold-Weather Skin': 'Strong match', 'Daily Moisturizer': 'Match',
        'Frequent Travelers': 'Strong match', 'Minimalist Skincare': 'Strong match',
        'Deep Nourishment': 'Match',
      },
      concerns: {
        Face: {
          'Sun damage': 'Strong match', Dryness: 'Match', 'Dark spots': 'Match',
          'Uneven tone': 'Strong match', 'Rough texture': 'Match', Scars: 'Match',
          Breakouts: 'Strong match', 'Sensitive skin': 'Strong match',
          'Barrier support': 'Strong match', 'Skin elasticity': 'Strong match',
          'Simple & easy skincare': 'Strong match',
          'Recovery after sun exposure': 'Strong match',
        },
        Hair: {
          Breakage: 'Strong match', Dryness: 'Match', 'Frizzy hair': 'Strong match',
          'Curly hair': 'Strong match', 'Treated hair': 'Strong match',
          'Scalp care': 'Strong match', 'Simple & easy hair care': 'Strong match',
        },
        Hands: {
          Dryness: 'Strong match', 'Nail cuticles': 'Strong match',
          'Simple & easy hand care': 'Strong match',
        },
        Body: {
          Elbows: 'Strong match', Knees: 'Strong match', Dryness: 'Strong match',
          'Stretch marks': 'Strong match', Scars: 'Strong match',
          'Barrier support': 'Strong match', 'Simple & easy skincare': 'Strong match',
          'Recovery after sun exposure': 'Strong match',
        },
      },
    },
    babassu: {
      priority: 8,
      usage: {
        Face: 'Match', Hair: 'Match', Hands: 'Match',
        Body: 'Match', 'More than one area': 'Strong match',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Match', 'Post-Workout Skin': 'Strong match',
        'Cold-Weather Skin': 'Strong match', 'Daily Moisturizer': 'Match',
        'Minimalist Skincare': 'Strong match', 'Deep Nourishment': 'Match',
      },
      concerns: {
        Face: {
          Dryness: 'Match', 'Rough texture': 'Match', Breakouts: 'Match',
          'Sensitive skin': 'Match', 'Barrier support': 'Match',
          'Simple & easy skincare': 'Match',
        },
        Hair: {
          Shininess: 'Strong match', Breakage: 'Match', Styling: 'Match',
          Dryness: 'Match', 'Frizzy hair': 'Match', 'Curly hair': 'Match',
          'Treated hair': 'Match', 'Scalp care': 'Match',
          'Simple & easy hair care': 'Match',
        },
        Hands: {
          Dryness: 'Match', 'Nail cuticles': 'Match', 'Simple & easy hand care': 'Match',
        },
        Body: {
          Elbows: 'Match', Knees: 'Match', Dryness: 'Match',
          'Barrier support': 'Match', 'Simple & easy skincare': 'Match',
        },
      },
    },
    baobab: {
      priority: 10,
      usage: {
        Face: 'Strong match', Hair: 'Match', Hands: 'Strong match',
        Body: 'Strong match', 'More than one area': 'Strong match',
      },
      lifestyle: {
        'Youthful Skin': 'Match', 'Cold-Weather Skin': 'Strong match',
        'Daily Moisturizer': 'Strong match', 'Frequent Travelers': 'Strong match',
        'Minimalist Skincare': 'Strong match', 'Deep Nourishment': 'Strong match',
      },
      concerns: {
        Face: {
          'Sun damage': 'Match', Dryness: 'Strong match', 'Uneven tone': 'Match',
          'Rough texture': 'Strong match', Scars: 'Match', 'Fine lines': 'Match',
          'Sensitive skin': 'Strong match', 'Barrier support': 'Strong match',
          'Skin elasticity': 'Match', Glow: 'Match',
          'Simple & easy skincare': 'Strong match',
          'Recovery after sun exposure': 'Match',
        },
        Hair: {
          Shininess: 'Match', Breakage: 'Match', Styling: 'Match',
          Dryness: 'Strong match', 'Curly hair': 'Match', 'Treated hair': 'Match',
          'Scalp care': 'Strong match', 'Simple & easy hair care': 'Match',
        },
        Hands: {
          Dryness: 'Strong match', 'Nail cuticles': 'Strong match',
          'Simple & easy hand care': 'Strong match',
        },
        Body: {
          Elbows: 'Strong match', Knees: 'Strong match', Dryness: 'Strong match',
          'Stretch marks': 'Strong match', Scars: 'Strong match',
          'Barrier support': 'Strong match', 'Simple & easy skincare': 'Strong match',
          'Recovery after sun exposure': 'Match',
        },
      },
    },
    brazilnut: {
      priority: 4,
      usage: {
        Face: 'Strong match', Hair: 'Strong match', Hands: 'Strong match',
        Body: 'Strong match', 'More than one area': 'Strong match',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Match', 'Youthful Skin': 'Match',
        'Cold-Weather Skin': 'Match', 'Daily Moisturizer': 'Match',
        'Frequent Travelers': 'Strong match', 'Minimalist Skincare': 'Strong match',
        'Deep Nourishment': 'Strong match',
      },
      concerns: {
        Face: {
          Dryness: 'Match', 'Dark spots': 'Match', 'Uneven tone': 'Match',
          'Rough texture': 'Match', Scars: 'Strong match', 'Fine lines': 'Strong match',
          'Barrier support': 'Match', 'Skin elasticity': 'Strong match', Glow: 'Match',
          'Simple & easy skincare': 'Match', 'Recovery after sun exposure': 'Match',
        },
        Hair: {
          Shininess: 'Match', Breakage: 'Strong match', Styling: 'Match',
          Dryness: 'Strong match', 'Frizzy hair': 'Match', 'Curly hair': 'Strong match',
          'Treated hair': 'Strong match', 'Simple & easy hair care': 'Match',
        },
        Hands: {
          Dryness: 'Strong match', 'Nail cuticles': 'Strong match',
          'Simple & easy hand care': 'Match',
        },
        Body: {
          Elbows: 'Strong match', Knees: 'Strong match', Dryness: 'Strong match',
          'Stretch marks': 'Match', Scars: 'Strong match', 'Barrier support': 'Match',
          'Simple & easy skincare': 'Match', 'Recovery after sun exposure': 'Match',
        },
      },
    },
    buriti: {
      priority: 5,
      usage: {
        Face: 'Strong match', Hair: 'Strong match', Hands: 'Match',
        Body: 'Match', 'More than one area': 'Match',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Strong match', 'Youthful Skin': 'Strong match',
        'Minimalist Skincare': 'Match', 'Deep Nourishment': 'Strong match',
      },
      concerns: {
        Face: {
          'Sun damage': 'Strong match', 'Dark spots': 'Strong match',
          'Uneven tone': 'Strong match', 'Rough texture': 'Strong match',
          Scars: 'Strong match', 'Fine lines': 'Strong match',
          'Skin elasticity': 'Strong match', Glow: 'Strong match',
          'Recovery after sun exposure': 'Strong match',
        },
        Hair: {
          Shininess: 'Strong match', Breakage: 'Match', Styling: 'Strong match',
          Dryness: 'Strong match', 'Frizzy hair': 'Strong match',
          'Curly hair': 'Strong match', 'Treated hair': 'Strong match',
          'Simple & easy hair care': 'Match',
        },
        Hands: {
          Dryness: 'Match', 'Nail cuticles': 'Match', 'Simple & easy hand care': 'Match',
        },
        Body: {
          Elbows: 'Match', Knees: 'Match', Dryness: 'Match', 'Stretch marks': 'Match',
          Scars: 'Match', 'Barrier support': 'Match', 'Simple & easy skincare': 'Match',
          'Recovery after sun exposure': 'Strong match',
        },
      },
    },
    pracaxi: {
      priority: 2,
      usage: {
        Face: 'Strong match', Hair: 'Strong match', Hands: 'Strong match',
        Body: 'Strong match', 'More than one area': 'Strong match',
      },
      lifestyle: {
        'Youthful Skin': 'Strong match', 'Post-Workout Skin': 'Strong match',
        'Cold-Weather Skin': 'Strong match', 'Frequent Travelers': 'Strong match',
        'Minimalist Skincare': 'Strong match', 'Deep Nourishment': 'Strong match',
      },
      concerns: {
        Face: Object.fromEntries(concernOptions.Face.map((concern) => [concern, 'Strong match'])),
        Hair: Object.fromEntries(concernOptions.Hair.map((concern) => [concern, 'Strong match'])),
        Hands: Object.fromEntries(concernOptions.Hands.map((concern) => [concern, 'Strong match'])),
        Body: Object.fromEntries(concernOptions.Body.map((concern) => [concern, 'Strong match'])),
      },
    },
    sandalwood: {
      priority: 9,
      usage: {
        Face: 'Match', Hair: 'Match', 'More than one area': 'Match',
      },
      lifestyle: {
        'Post-Workout Skin': 'Strong match', 'Minimalist Skincare': 'Match',
      },
      concerns: {
        Face: {
          Dryness: 'Match', 'Uneven tone': 'Match',
        },
        Hair: {
          'Scalp care': 'Match',
        },
        Hands: {},
        Body: {},
      },
    },
    'sun-enhancing-body-oil': {
      priority: 1,
      usage: {
        Face: 'Exclude', Hair: 'Exclude', Hands: 'Exclude',
        Body: 'Strong match', 'More than one area': 'Exclude',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Strong match', 'Youthful Skin': 'Exclude',
        'Post-Workout Skin': 'Exclude', 'Cold-Weather Skin': 'Exclude',
        'Daily Moisturizer': 'Exclude', 'Frequent Travelers': 'Strong match',
        'Minimalist Skincare': 'Match', 'Deep Nourishment': 'Exclude',
      },
      concerns: {
        Face: {
          ...Object.fromEntries(concernOptions.Face.slice(0, -1).map((concern) => [concern, 'Exclude'])),
          'Recovery after sun exposure': 'Strong match',
        },
        Hair: Object.fromEntries(concernOptions.Hair.map((concern) => [concern, 'Exclude'])),
        Hands: Object.fromEntries(concernOptions.Hands.map((concern) => [concern, 'Exclude'])),
        Body: {
          Elbows: 'Exclude', Knees: 'Exclude', Dryness: 'Exclude',
          'Stretch marks': 'Exclude', Scars: 'Exclude', 'Barrier support': 'Exclude',
          'Simple & easy skincare': 'Match', 'Recovery after sun exposure': 'Strong match',
        },
      },
    },
    tamanu: {
      priority: 11,
      usage: {
        Face: 'Match', Hair: 'Match', Body: 'Match', 'More than one area': 'Match',
      },
      lifestyle: {
        'Post-Workout Skin': 'Strong match', 'Minimalist Skincare': 'Strong match',
      },
      concerns: {
        Face: {
          Scars: 'Strong match', Breakouts: 'Match',
        },
        Hair: {
          Breakage: 'Match', Dryness: 'Match', 'Scalp care': 'Match',
        },
        Hands: {},
        Body: {
          'Stretch marks': 'Strong match', Scars: 'Strong match',
        },
      },
    },
    tucuma: {
      priority: 6,
      usage: {
        Face: 'Match', Hair: 'Match', 'More than one area': 'Match',
      },
      lifestyle: {
        'Beach/Sun Lovers': 'Match', 'Minimalist Skincare': 'Match',
        'Deep Nourishment': 'Match',
      },
      concerns: {
        Face: {
          Dryness: 'Strong match', 'Rough texture': 'Strong match',
        },
        Hair: {
          Shininess: 'Match', Breakage: 'Match', Dryness: 'Match',
          'Frizzy hair': 'Match', 'Treated hair': 'Match', 'Scalp care': 'Match',
        },
        Hands: {},
        Body: {},
      },
    },
  };

  const isPositiveMatch = (strength) => strength === 'Match' || strength === 'Strong match';

  function positiveSearchTermsForMapping(mapping) {
    const terms = [];

    Object.entries(mapping.usage || {}).forEach(([term, strength]) => {
      if (term !== 'More than one area' && isPositiveMatch(strength)) terms.push(term);
    });
    Object.entries(mapping.lifestyle || {}).forEach(([term, strength]) => {
      if (term !== 'None' && isPositiveMatch(strength)) terms.push(term);
    });
    Object.values(mapping.concerns || {}).forEach((concerns) => {
      Object.entries(concerns || {}).forEach(([term, strength]) => {
        if (isPositiveMatch(strength)) terms.push(term);
      });
    });

    return [...new Set(terms)];
  }

  const searchTermsByHandle = Object.freeze(
    Object.fromEntries(
      Object.entries(mappings).map(([handle, mapping]) => [
        handle,
        Object.freeze(positiveSearchTermsForMapping(mapping)),
      ])
    )
  );

  if (typeof globalThis !== 'undefined') {
    globalThis.JiecAssessmentData = Object.freeze({searchTermsByHandle});
  }

  function scoreAssessmentProducts(products, answers, limit = 3) {
    const points = (strength) => strength === 'Strong match' ? 2 : strength === 'Match' ? 1 : 0;
    const ranked = products
      .map((product) => {
        let score = 0;
        let excluded = false;
        let usageMatched = false;
        const reasons = [];
        const apply = (strength, reason, isUsage = false) => {
          if (strength === 'Exclude') {
            excluded = true;
            return;
          }
          const value = points(strength);
          score += value;
          if (isUsage && value > 0) usageMatched = true;
          if (value > 0) reasons.push(reason);
        };

        answers.usage.forEach((value) => apply(product.usage?.[value], value, true));
        answers.lifestyle
          .filter((value) => value !== 'None')
          .forEach((value) => apply(product.lifestyle?.[value], value));
        Object.entries(answers.concerns).forEach(([area, selected]) => {
          selected.forEach((value) => apply(product.concerns?.[area]?.[value], value));
        });

        return {
          ...product,
          score,
          excluded,
          usageMatched,
          reasons: [...new Set(reasons)],
        };
      })
      .filter((product) => !product.excluded && product.usageMatched && product.score > 0)
      .sort((a, b) => b.score - a.score || a.priority - b.priority);

    return {
      ranked,
      recommendations: ranked.filter((product) => product.available).slice(0, limit),
    };
  }

  const hasBroadSelection = (answers) => answers.usage.includes('More than one area');
  const hasLifestyleStep = (answers) => !hasBroadSelection(answers)
    && answers.usage.some((area) => area === 'Face' || area === 'Body');
  const selectedConcernAreas = (answers) => hasBroadSelection(answers)
    ? Object.keys(concernOptions)
    : answers.usage.filter((area) => concernOptions[area]);
  const assessmentSteps = (answers) => [
    'usage',
    ...(hasLifestyleStep(answers) ? ['lifestyle'] : []),
    ...(selectedConcernAreas(answers).length ? ['concerns'] : []),
  ];

  function updateUsageAnswer(answers, value) {
    const selected = answers.usage.includes(value);
    if (value === 'More than one area') {
      return {
        usage: selected ? [] : ['More than one area'],
        lifestyle: [],
        concerns: {},
      };
    }

    const usage = selected
      ? answers.usage.filter((item) => item !== value && item !== 'More than one area')
      : [...answers.usage.filter((item) => item !== 'More than one area'), value];
    const concerns = Object.fromEntries(
      Object.entries(answers.concerns).filter(([area]) => usage.includes(area)),
    );

    return {
      usage,
      lifestyle: usage.some((area) => area === 'Face' || area === 'Body')
        ? [...answers.lifestyle]
        : [],
      concerns,
    };
  }

  function createIcon(documentRef, paths, direction = 'right') {
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = documentRef.createElementNS(namespace, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    if (direction === 'left') svg.style.transform = 'rotate(180deg)';
    paths.forEach((pathData) => {
      const path = documentRef.createElementNS(namespace, 'path');
      path.setAttribute('d', pathData);
      svg.append(path);
    });
    return svg;
  }

  function renderRecommendationCards(documentRef, resultGrid, products) {
    resultGrid.replaceChildren();
    products.forEach((product, index) => {
      const article = documentRef.createElement('article');
      article.className = 'jiec-assessment__match';
      article.dataset.productHandle = product.handle;
      article.dataset.resultRank = String(index + 1);

      if (product.image) {
        const image = documentRef.createElement('img');
        image.className = 'jiec-assessment__match-image';
        image.src = product.image;
        image.alt = product.title;
        image.width = 900;
        image.height = 900;
        article.append(image);
      } else {
        const placeholder = documentRef.createElement('div');
        placeholder.className = 'jiec-assessment__match-image';
        placeholder.setAttribute('aria-hidden', 'true');
        article.append(placeholder);
      }

      const copy = documentRef.createElement('div');
      copy.className = 'jiec-assessment__match-copy';
      const label = documentRef.createElement('p');
      label.className = 'jiec-assessment__match-label';
      label.textContent = index === 0 ? 'Best match' : 'Also consider';
      const title = documentRef.createElement('h2');
      title.textContent = product.title;
      const bestFor = documentRef.createElement('p');
      bestFor.textContent = product.bestFor;
      copy.append(label, title, bestFor);

      if (product.reasons.length) {
        const reasons = documentRef.createElement('p');
        reasons.className = 'jiec-assessment__match-reasons';
        reasons.textContent = `Matches: ${product.reasons.slice(0, 4).join(', ')}`;
        copy.append(reasons);
      }

      const links = documentRef.createElement('div');
      links.className = 'jiec-assessment__match-links';
      const productLink = documentRef.createElement('a');
      productLink.href = product.productUrl || `/products/${product.handle}`;
      productLink.append(
        documentRef.createTextNode(`View product — ${product.price} `),
        createIcon(documentRef, ['M5 12h14', 'm12 5 7 7-7 7']),
      );
      links.append(productLink);

      if (product.ingredientHandle) {
        const ingredientLink = documentRef.createElement('a');
        ingredientLink.href = `/blogs/ingredient-encyclopedia/${product.ingredientHandle}`;
        ingredientLink.textContent = `Read about ${product.ingredientName || product.title}`;
        links.append(ingredientLink);
      }

      copy.append(links);
      article.append(copy);
      resultGrid.append(article);
    });
  }

  function applyResultState(resultGrid, noMatch, unavailable, scoreResult) {
    const hasLogicalMatches = scoreResult.ranked.length > 0;
    const hasAvailableMatches = scoreResult.recommendations.length > 0;
    noMatch.hidden = hasLogicalMatches;
    unavailable.hidden = !hasLogicalMatches || hasAvailableMatches;
    resultGrid.hidden = !hasAvailableMatches;
  }

  function resultPresentation(scoreResult) {
    if (scoreResult.recommendations.length > 0) {
      const count = scoreResult.recommendations.length;
      return {
        heading: 'Start with these JIEC Labs oils.',
        announcement: `${count} available ${count === 1 ? 'match' : 'matches'} found.`,
      };
    }
    if (scoreResult.ranked.length > 0) {
      return {
        heading: 'Your strongest matches are currently sold out.',
        announcement: 'Your strongest matches are currently unavailable.',
      };
    }
    return {
      heading: 'We couldn’t find a close match for those answers.',
      announcement: 'No close match was found for these answers.',
    };
  }

  function focusAssessmentView(step, questionHeading, resultsHeading) {
    const target = step === 'results' ? resultsHeading : questionHeading;
    target.focus({preventScroll: true});
  }

  function updateAssessmentProgress(documentRef, progress, currentSteps, step) {
    const index = step === 'results' ? currentSteps.length : currentSteps.indexOf(step);
    const value = step === 'results' ? currentSteps.length : index + 1;
    const text = step === 'results'
      ? `Assessment complete. ${currentSteps.length} questions answered.`
      : `Question ${value} of ${currentSteps.length}.`;

    progress.style.gridTemplateColumns = `repeat(${currentSteps.length}, 1fr)`;
    progress.setAttribute('aria-valuemax', String(currentSteps.length));
    progress.setAttribute('aria-valuenow', String(value));
    progress.setAttribute('aria-valuetext', text);
    progress.replaceChildren(...currentSteps.map((_, itemIndex) => {
      const span = documentRef.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      if (itemIndex <= index) span.className = 'is-complete';
      return span;
    }));

    return {index, text, value};
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      applyResultState,
      assessmentSteps,
      concernOptions,
      focusAssessmentView,
      hasBroadSelection,
      hasLifestyleStep,
      lifestyleOptions,
      mappings,
      positiveSearchTermsForMapping,
      renderRecommendationCards,
      resultPresentation,
      searchTermsByHandle,
      scoreAssessmentProducts,
      selectedConcernAreas,
      updateAssessmentProgress,
      updateUsageAnswer,
      usageAreas,
    };
  }

  if (typeof document === 'undefined') return;

  const checkIcon = () => createIcon(document, ['M20 6 9 17l-5-5']);
  const arrowIcon = (direction) => createIcon(document, ['M5 12h14', 'm12 5 7 7-7 7'], direction);

  function initializeAssessment(root) {
    if (root.dataset.assessmentReady === 'true') return;

    const question = root.querySelector('[data-assessment-question]');
    const results = root.querySelector('[data-assessment-results]');
    const progress = root.querySelector('[data-assessment-progress]');
    const number = root.querySelector('[data-question-number]');
    const heading = root.querySelector('[data-question-heading]');
    const resultsHeading = root.querySelector('[data-results-heading]');
    const help = root.querySelector('[data-question-help]');
    const choices = root.querySelector('[data-assessment-choices]');
    const next = root.querySelector('[data-assessment-next]');
    const questionBack = root.querySelector('[data-assessment-question] [data-assessment-back]');
    const resultsBack = root.querySelector('[data-assessment-results] [data-assessment-back]');
    const restart = root.querySelector('[data-assessment-restart]');
    const resultGrid = root.querySelector('[data-assessment-results-grid]');
    const noMatch = root.querySelector('[data-assessment-empty-no-match]');
    const unavailable = root.querySelector('[data-assessment-empty-unavailable]');
    const status = root.querySelector('[data-assessment-status]');
    if (!question || !results || !progress || !number || !heading || !resultsHeading || !help || !choices || !next || !resultGrid || !noMatch || !unavailable || !status) return;

    root.dataset.assessmentReady = 'true';

    const products = Array.from(root.querySelectorAll('[data-assessment-product]'))
      .map((item) => ({
        handle: item.dataset.handle,
        title: item.dataset.title,
        price: item.dataset.price,
        image: item.dataset.image,
        productUrl: item.dataset.productUrl,
        available: item.dataset.available === 'true',
        bestFor: item.dataset.bestFor,
        ingredientHandle: item.dataset.ingredientHandle,
        ingredientName: item.dataset.ingredientName,
        ...mappings[item.dataset.handle],
      }))
      .filter((product) => product.handle && product.usage);

    let step = 'usage';
    let answers = {usage: [], lifestyle: [], concerns: {}};

    // The email step submits a Shopify form, which reloads the page. Save the answers in the
    // browser session so the assessment can reopen on the results after that reload.
    const STATE_KEY = 'jiecAssessmentState';
    const RESUME_KEY = 'jiecAssessmentResume';
    const storage = (() => {
      try { return window.sessionStorage; } catch (error) { return null; }
    })();
    const saveState = () => {
      if (!storage) return;
      try { storage.setItem(STATE_KEY, JSON.stringify({answers, step})); } catch (error) { /* storage unavailable */ }
    };
    const readResume = () => {
      if (!storage) return null;
      try {
        const flag = storage.getItem(RESUME_KEY);
        storage.removeItem(RESUME_KEY);
        if (!flag || Date.now() - Number(flag) > 30 * 60 * 1000) return null;
        const saved = JSON.parse(storage.getItem(STATE_KEY) || 'null');
        if (!saved || !saved.answers || !Array.isArray(saved.answers.usage)) return null;
        const restored = {
          usage: saved.answers.usage.filter((value) => usageAreas.includes(value)),
          lifestyle: Array.isArray(saved.answers.lifestyle)
            ? saved.answers.lifestyle.filter((value) => lifestyleOptions.includes(value))
            : [],
          concerns: Object.fromEntries(
            Object.entries(saved.answers.concerns || {})
              .filter(([area, list]) => concernOptions[area] && Array.isArray(list))
              .map(([area, list]) => [area, list.filter((value) => concernOptions[area].includes(value))]),
          ),
        };
        return restored.usage.length ? restored : null;
      } catch (error) {
        return null;
      }
    };
    const concernAreas = () => selectedConcernAreas(answers);
    const steps = () => assessmentSteps(answers);

    // Save the selections and matches on the customer record: the email step's Shopify form
    // adds them as customer tags, alongside 'newsletter' and 'source-assessment'.
    const tagsInput = root.querySelector('[data-assessment-gate] input[name="contact[tags]"]');
    const baseTags = tagsInput ? tagsInput.value : '';
    const cleanTag = (text) => String(text).replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
    const updateTags = () => {
      if (!tagsInput) return;
      const tags = [];
      answers.usage.forEach((value) => tags.push(`assessment-area: ${value}`));
      answers.lifestyle.forEach((value) => tags.push(`assessment-routine: ${value}`));
      Object.entries(answers.concerns).forEach(([area, list]) => {
        (list || []).forEach((value) => tags.push(`assessment-concern: ${area} - ${value}`));
      });
      scoreAssessmentProducts(products, answers).recommendations.forEach((product, index) => {
        tags.push(`${index === 0 ? 'assessment-best-match' : 'assessment-match'}: ${product.title}`);
      });
      tagsInput.value = [baseTags, ...tags.map(cleanTag)].filter(Boolean).join(',');
    };

    const toggle = (items, value) => items.includes(value)
      ? items.filter((item) => item !== value)
      : [...items, value];

    function refocusChoice(value, area = '') {
      const replacement = Array.from(choices.querySelectorAll('[data-choice-value]'))
        .find((item) => item.dataset.choiceValue === value && item.dataset.choiceArea === area);
      replacement?.focus({preventScroll: true});
    }

    function choiceButton(label, selected, onClick, area = '') {
      const button = document.createElement('button');
      button.className = `jiec-assessment__choice${selected ? ' is-selected' : ''}`;
      button.type = 'button';
      button.setAttribute('aria-pressed', String(selected));
      button.dataset.choiceValue = label;
      button.dataset.choiceArea = area;
      const text = document.createElement('span');
      text.textContent = label;
      button.append(text, checkIcon());
      button.addEventListener('click', onClick);
      return button;
    }

    function renderChoices() {
      choices.replaceChildren();
      choices.className = step === 'concerns'
        ? 'jiec-assessment__concern-groups'
        : 'jiec-assessment__choices';

      if (step === 'usage') {
        usageAreas.forEach((value) => choices.append(choiceButton(value, answers.usage.includes(value), () => {
          answers = updateUsageAnswer(answers, value);
          render(false);
          refocusChoice(value);
        })));
        return;
      }

      if (step === 'lifestyle') {
        lifestyleOptions.forEach((value) => choices.append(choiceButton(value, answers.lifestyle.includes(value), () => {
          answers.lifestyle = value === 'None'
            ? (answers.lifestyle.includes(value) ? [] : ['None'])
            : toggle(answers.lifestyle.filter((item) => item !== 'None'), value);
          render(false);
          refocusChoice(value);
        })));
        return;
      }

      concernAreas().forEach((area) => {
        const group = document.createElement('section');
        group.className = 'jiec-assessment__concern-group';
        const title = document.createElement('h2');
        title.textContent = area;
        const grid = document.createElement('div');
        grid.className = 'jiec-assessment__choices';
        concernOptions[area].forEach((value) => grid.append(choiceButton(value, (answers.concerns[area] || []).includes(value), () => {
          answers.concerns[area] = toggle(answers.concerns[area] || [], value);
          render(false);
          refocusChoice(value, area);
        }, area)));
        group.append(title, grid);
        choices.append(group);
      });
    }

    function canContinue() {
      if (step === 'usage') return answers.usage.length > 0;
      if (step === 'lifestyle') return answers.lifestyle.length > 0;
      return concernAreas().some((area) => (answers.concerns[area] || []).length > 0);
    }

    function scoreProducts() {
      return scoreAssessmentProducts(products, answers);
    }

    function renderResults() {
      const scoreResult = scoreProducts();
      renderRecommendationCards(document, resultGrid, scoreResult.recommendations);
      applyResultState(resultGrid, noMatch, unavailable, scoreResult);
      const presentation = resultPresentation(scoreResult);
      resultsHeading.textContent = presentation.heading;
      status.textContent = presentation.announcement;
    }

    function scrollToAssessment() {
      const headerOffset = window.matchMedia('(max-width: 749px)').matches ? 120 : 180;
      const top = Math.max(0, root.getBoundingClientRect().top + window.scrollY - headerOffset);
      window.scrollTo({top, behavior: 'instant'});
    }

    function render(shouldScroll) {
      const currentSteps = steps();
      if (step !== 'results' && !currentSteps.includes(step)) step = currentSteps.at(-1);
      saveState();
      updateTags();
      const {index, text: progressText} = updateAssessmentProgress(document, progress, currentSteps, step);

      question.hidden = step === 'results';
      results.hidden = step !== 'results';

      if (step === 'results') {
        renderResults();
        if (shouldScroll) {
          focusAssessmentView(step, heading, resultsHeading);
          scrollToAssessment();
        }
        return;
      }

      const content = {
        usage: ['Where will you use it most?', 'Select all that apply.'],
        lifestyle: ['Which routines sound most like yours?', 'Select all that apply, or choose None.'],
        concerns: ['What would you most like help with?', 'Select all that apply in each area.'],
      }[step];

      number.textContent = `Question ${index + 1}`;
      heading.textContent = content[0];
      help.textContent = content[1];
      renderChoices();
      next.disabled = !canContinue();
      next.replaceChildren(
        document.createTextNode(step === 'concerns' ? 'See my matches ' : 'Continue '),
        arrowIcon('right'),
      );
      questionBack.disabled = step === 'usage';
      if (shouldScroll) {
        status.textContent = `${progressText} ${content[0]}`;
        focusAssessmentView(step, heading, resultsHeading);
        scrollToAssessment();
      }
    }

    next.addEventListener('click', () => {
      const currentSteps = steps();
      step = currentSteps[currentSteps.indexOf(step) + 1] || 'results';
      render(true);
    });

    questionBack.addEventListener('click', () => {
      const currentSteps = steps();
      step = currentSteps[Math.max(0, currentSteps.indexOf(step) - 1)];
      render(true);
    });

    resultsBack?.addEventListener('click', () => {
      step = steps().at(-1);
      render(true);
    });

    restart?.addEventListener('click', () => {
      answers = {usage: [], lifestyle: [], concerns: {}};
      step = 'usage';
      render(true);
    });

    const resumed = readResume();
    if (resumed) {
      answers = resumed;
      step = 'results';
      render(true);
      if (window.history && window.history.replaceState && /customer_posted/.test(window.location.search)) {
        window.history.replaceState(null, '', window.location.pathname);
      }
    } else {
      render(false);
    }
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-jiec-assessment]').forEach(initializeAssessment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
